import { Controller } from "@hotwired/stimulus"
import { debounce, patchJson, sessionIdFor } from "./sweeper_shared"

export default class extends Controller {
  update(event) {
    const field = event.target.closest("[data-meta]")
    if (!field) return

    const sessionId = sessionIdFor(field)
    if (!sessionId) return

    debounce(this, `metadata:${field.dataset.meta}`, () => {
      patchJson(`/api/v1/sessions/${encodeURIComponent(sessionId)}/metadata`, {
        [field.dataset.meta]: field.value
      })
    })
  }
}
